
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.101 1A1.086 1.086 0 000 1.46v7.08c0 .165.036.321.101.46L4 5 .101 1zM12 .112A1.008 1.008 0 0011.538 0H1.462C1.297 0 1.14.04 1 .112L6.5 6 12 .112zM12.899 9c.065-.139.101-.295.101-.46V1.46c0-.165-.036-.321-.101-.46L9 5l3.899 4zM6.753 7.127a.364.364 0 01-.253.1.364.364 0 01-.253-.1L5.071 6 1 9.9c.14.064.296.1.462.1h10.076c.165 0 .322-.036.462-.1L7.929 6 6.753 7.127z","fill":"#fff"}})])
          )
        }
      }
    